import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const ItensLancamentoList = props => <DefaultDataTable data={props} />;
